export const INFOS = [
    {
        id: 0,
        name: "Who We Are",
        image: "/assets/images/whoWeAre.jpeg",
        elevation: 1233,
        featured:true,
        description:"Time Tax is a private firm established in Addis Ababa , Ethiopia (East Africa) on December 9, 2009. We provide Tax filing, Valuation and audit services. We are certified by Board of Accountancy & Valuation in Ethiopia as Grade A to provide, Tax filing, Auditing, Assets valuation and consultancy services.We have more than 11 years experience."
    },
    {
        id: 1,
        name:"Do you need Assistant",
        image: "/assets/images/image2.png",
        elevation: 877,
        featured: false,
        description: "We offer professional assistance only!"
    },
    {
        id: 2,
        name:"Accounting",
        image: "/assets/images/node-logo.png",
        elevation: 2901,
        featured: false,
        description:"Prepare asset, liability, and capital account entries by compiling and analyzing account information. Document financial transactions by entering account information.Summarize current financial status by collecting information; preparing balance sheet, profit and loss statement, and other reports."
    },
];